import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';
import { radiusHalf } from 'utility/borderRadius';
import { bloxValues } from 'themes/constants';
import { getSolidThemeGray, getBorderString } from 'utility/styles';

export const inputContainerStyle = (
  theme: Theme,
  disabled?: boolean,
): SystemStyleObject => ({
  width: '100%',
  cursor: disabled ? 'default' : 'pointer',
  borderRadius: radiusHalf(theme),
  '& .input-field.input-array .tiptap.ProseMirror': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    padding: '4px 8px',
  },
  '& p:not(:has(br.ProseMirror-trailingBreak))': {
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '8px',
    paddingRight: '8px',
    whiteSpace: 'nowrap',
    borderRadius: '16px',
  },
});

export const getISDDialogStyle = (theme: Theme): SystemStyleObject => ({
  '& .MuiDialog-paper': {
    minHeight: '95vh',
  },
  '& .MuiDialogTitle-root': {
    px: 2,
    py: 1,
    minHeight: '57px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: bloxValues.xxlFontSizeRem,
    bgcolor: getSolidThemeGray(theme),
    borderBottom: getBorderString(theme),
  },
  '& .MuiDialogActions-root': {
    px: 2,
    py: 1,
    bgcolor: getSolidThemeGray(theme),
    borderTop: getBorderString(theme),
  },
  '& .MuiDialogContent-root': {
    display: 'grid',
    gridTemplateColumns: 'auto',
    px: 1,
    py: 0,
  },
  '& .MuiMenuItem-root': {
    padding: 0,
  },
});

export const getDialogContentStyle = (theme: Theme): SystemStyleObject => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1E1E1E' : 'inherit',
});
